import React, { Component } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faPlusCircle, faRecycle, faSlash, faUserEdit, faUmbrellaBeach, faUserClock } from "@fortawesome/free-solid-svg-icons";
import { Box, Text, Button, ButtonGroup, Center, Spacer } from '@chakra-ui/react';
import UserGrid from "./UserGrid.jsx";
import ModalUserDialog from "./ModalUserDialog";

import ConfigService from "../../../services/ConfigService.js";
import AuthResourceService from "../../../services/AuthResourceService.js";

import AuthUser from "../../../models/AuthUser.js";


const DelSwal = withReactContent(Swal);


export default class UserPanel extends Component {
  constructor(props) {
    super(props);

    this.syncTimer = null;
    this.configService = new ConfigService();
    this.authResourceService = new AuthResourceService();

    this.state = {
      editMode: "add",
      userData: null,
      currentUser: null,
      activeStatus: null,
      isLoadingGrid: false,
      orgLocations: []
    };

    this.refreshData = this.refreshData.bind(this);
    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onNewRequest = this.onNewRequest.bind(this);
    this.onEditRequest = this.onEditRequest.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);

    this.closeNewModal = this.closeNewModal.bind(this);
    this.postNew = this.postNew.bind(this);
    this.postUpdated = this.postUpdated.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);
    this.onBtnToggleRetireSelectedUser = this.onBtnToggleRetireSelectedUser.bind(this);

  }

  async componentDidMount() {
    await this.refreshData();
  }

  async refreshData() {
    this.setState({ isLoadingGrid: true });
    var gridDataResponse = await this.authResourceService.getAppUsers(this.props.userSession.gcid, this.props.userSession.token);
    if (gridDataResponse.hasError) {
      this.props.onErrorPageRequest("Error fetching organization users.");
      return;
    }
    var allUsers = gridDataResponse.dataResult;
    // suppress system users.
    var systemUsers = this.configService.getSystemUsers();
    var displayUsers = allUsers.filter(user => !systemUsers.includes(user.clientId));

    console.log("User Data:");
    console.info(displayUsers);
    this.setState({
      userData: displayUsers,
      selectedRow: null, // reset
      isLoadingGrid: false,
      syncing: false
    });
  }


  onRowSelectChange(newSelectedRow) {
    console.log("OnRowSelectChange");
    console.log("set state for selectedRow");
    console.info(newSelectedRow);
    var newActiveStatus = newSelectedRow.enabled;
    this.setState({
      currentUser: newSelectedRow,
      activeStatus: newActiveStatus
    });
  }

  onNewRequest() {
    this.setState({
      editMode: "add",
      showNewSubModal: true
    });
  }

  async onEditRequest() {
    if (!this.state.currentUser) {
      DelSwal.fire({ icon: "error", title: "Edit User", text: "Select a user first!" });
      return;
    }
    this.setState({
      editMode: "update",
      showNewSubModal: true
    });
  }

  closeNewModal() {
    this.setState({ showNewSubModal: false })
  }

  async postNew(user) {
    console.log("User to be posted:");
    console.info(user);
    var authUser = new AuthUser(user.gcid, user.clientId, user.clientName, user.description, user.password, user.app, false, user.roles, [], [], 60 * 240); //user.locations, user.schemas, 60 * 240);
    console.log("AuthUser to be posted:");
    console.info(authUser);
    var result = await this.authResourceService.postAppUser(authUser, this.props.userSession.gcid, this.props.userSession.token);
    this.closeNewModal();
    if (result.hasError) {
      toast.error("Error posting new user " + user.clientName + ". " + result.messages[0]);
    }
    else {
      toast.success(" new user " + user.clientName + " has been added.");
    }
    await this.refreshData();


  }



  async postUpdated(user) {
    console.log("User to be posted:");
    console.info(user);
    var authUser = new AuthUser(user.gcid, user.clientId, user.clientName, user.description, user.password, user.app, false, user.roles, [], [], 60 * 240); //, user.locations, user.schemas, 60 * 240);
    console.log("AuthUser to be posted:");
    console.info(authUser);
    var result = await this.authResourceService.postAppUser(authUser, this.props.userSession.gcid, this.props.userSession.token);
    this.closeNewModal();
    if (result.hasError) {
      toast.error("Error posting user " + user.clientName + ". " + result.messages[0]);
    }
    else {
      toast.success("user " + user.clientName + " has been updated. Be sure to have the user log out and back in to refresh user rights.");
    }
    await this.refreshData();
  }

  async onDeleteRequest() {
    if (!this.state.currentUser) {
      DelSwal.fire({ icon: "error", title: "Remove User", text: "Select a user to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove User?",
          text: "Confirm you want to permanently remove the existing user " + this.state.currentUser.clientName,
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          await this.authResourceService.deleteAppUser(this.state.currentUser.clientId, this.props.userSession.gcid, this.props.userSession.token);
          await this.refreshData();
          var currentUserName = this.state.currentUser.clientName;
          this.setState({ currentUser: null });
          return DelSwal.fire({ icon: "success", text: currentUserName + " has been permanently deleted." });
        }
      }
      );
  }

  async onBtnToggleRetireSelectedUser() {
    console.log("Current Status: " + this.state.activeStatus);
    console.log("New Status: " + (!this.state.activeStatus));
    var statusWord = (this.state.activeStatus) ? "retire" : "activate";
    if (!this.state.currentUser) {
      DelSwal.fire({ icon: "error", title: "Toggle User", text: "Select a user first!" });
      return;
    }
    console.log("Current User:");
    console.info(this.state.currentUser);
    var userId = this.state.currentUser.clientId;
    DelSwal.fire({
      icon: "question",
      title: statusWord + " User?",
      text: "Confirm you want to " + statusWord + " user " + userId,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel"
    })
      .then(async (result) => {
        if (result.value) {
          var serviceResponse = await this.authResourceService.postAppUserEnabledFlag(userId, !this.state.activeStatus, this.props.userSession.gcid, this.props.userSession.token);
          await this.refreshData();
          this.setState({ currentUser: null });
          if (serviceResponse.hasError) {
            return DelSwal.fire({ icon: "error", text: userId + " has NOT been " + statusWord + "d. There was an error posting: " + serviceResponse.messages[0] });
          }
          else {
            return DelSwal.fire({ icon: "success", text: userId + " has been " + statusWord + "d." });
          }
        }
      });
  }



  render() {

    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );


    var systemRoles = this.configService.getSystemRoles();
    // remove system roles
    var filteredRoles = this.props.roles.filter((role) => { return (!systemRoles.includes(role.id))});

    return (
      <div id="admin-panel">

        <div>
          <ModalUserDialog
            showNewModal={this.state.showNewSubModal}
            closeNewModal={this.closeNewModal}
            postNew={this.postNew}
            postUpdated={this.postUpdated}
            userSession={this.props.userSession}
            editMode={this.state.editMode}
            currentUser={this.state.currentUser}
            gridData={this.state.userData}
            roles={filteredRoles}
            //locations={this.props.locations}
            //schemas={this.props.schemas}
          />
        </div>

        <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

          <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>User Maintenance</Text>
          <Center margin='10px'>
            <ButtonGroup isAttached>
              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faPlusCircle} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={(e) => this.onNewRequest(e)}
              >
                New
              </Button>

              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faUserEdit} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={(e) => this.onEditRequest(e)}
              >
                Edit
              </Button>

              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={(this.state.activeStatus) ? faUmbrellaBeach : faUserClock} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={(e) => this.onBtnToggleRetireSelectedUser(e)}
              >
                {(this.state.activeStatus) ? "Retire" : "Activate"}
              </Button>

              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faSlash} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={(e) => this.onDeleteRequest(e)}
              >
                Delete
              </Button>

              <Button
                variant="solid"
                leftIcon={<FontAwesomeIcon icon={faRecycle} />}
                bg='#0095c8'
                color='white'
                fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                onClick={(e) => this.refreshData(e)}
              >
                Refresh
              </Button>
            </ButtonGroup>
            {loadingGridIcon}
          </Center>

          <UserGrid
            rowData={this.state.userData}
            onRowSelectChange={this.onRowSelectChange}
            onEditRequest={this.onEditRequest}
          />

        </Box >

      </div >
    );
  }
}
